import React, { useState } from 'react';
import { Table, Tag, Switch, Space, Modal, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

interface User {
  id: number;
  username: string;
  email: string;
  role: string;
  status: boolean;
  lastLogin: string;
}

const Users: React.FC = () => {
  // 模拟数据
  const [users] = useState<User[]>([
    {
      id: 1,
      username: 'admin',
      email: 'admin@example.com',
      role: 'admin',
      status: true,
      lastLogin: '2023-12-20 10:00:00',
    },
    {
      id: 2,
      username: 'user1',
      email: 'user1@example.com',
      role: 'user',
      status: true,
      lastLogin: '2023-12-19 15:30:00',
    },
  ]);

  const handleStatusChange = (checked: boolean, record: User) => {
    Modal.confirm({
      title: '确认修改',
      content: `确定要${checked ? '启用' : '禁用'}用户 "${record.username}" 吗？`,
      onOk() {
        message.success(`已${checked ? '启用' : '禁用'}用户`);
      },
    });
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
      render: (text: string) => (
        <Space>
          <UserOutlined />
          {text}
        </Space>
      ),
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: '角色',
      dataIndex: 'role',
      key: 'role',
      render: (role: string) => (
        <Tag color={role === 'admin' ? 'red' : 'blue'}>
          {role.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: boolean, record: User) => (
        <Switch
          checked={status}
          onChange={(checked) => handleStatusChange(checked, record)}
        />
      ),
    },
    {
      title: '最后登录',
      dataIndex: 'lastLogin',
      key: 'lastLogin',
    },
    {
      title: '操作',
      key: 'action',
      render: (record: User) => (
        <Space size="middle">
          <a onClick={() => handleResetPassword(record)}>
            <LockOutlined /> 重置密码
          </a>
        </Space>
      ),
    },
  ];

  const handleResetPassword = (user: User) => {
    Modal.confirm({
      title: '重置密码',
      content: `确定要重置用户 "${user.username}" 的密码吗？`,
      onOk() {
        message.success('密码重置成功');
      },
    });
  };

  return (
    <div>
      <h2>用户管理</h2>
      <Table columns={columns} dataSource={users} rowKey="id" />
    </div>
  );
};

export default Users; 